module.exports = {
  EnrichedPlayer: {
    Allow_fullscreen: "Tam ekrana izin ver",
    Show_controls: "Kontrol butonlarını göster",
    Replay: "Tekrar oynat",
    Autoplay: "Otomatik oynat",
    URL: "URL",
    Video: "Video",
    background_color: "Arka Plan Rengi",
    border_color: "Çerçeve Rengi",
    border_size: "Çerçeve Genişliği",
    border_style: "Çerçeve Stili",
    box_style: "Kutu Stili",
    opacity: "Opaklık",
    padding: "Alan",
    pos: "An",
    PluginName: "Video",
    radius: "Radyan",
    source: "Kaynak",
    message_mark_error:
      "Yanlış bir değer seçtiniz.  Zaman formatı şu şekilde olmalıdır: saat:dakika:saniye veya dakika:saniye. Örneğin 1:33",
    AutoPlay: "Otomatik oynatma",
    Loop: "Döngü",
    Sound: "Ses",
    DownloadStyled: "Ayarlarla indir",
    DownloadStyledProgress: "Hazırlanıyor… %{{p}}",
    DownloadStyledCancel: "İptal et",
    DownloadStyledFailed: "İndirme başarısız",
    DownloadWithSound: "Sesli indir (kapatmak için tıkla)",
    DownloadMuted: "Sessiz indir (sesi açmak için tıkla)",
  },
};
